'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["report", "disableSVGs", "isMobile"];
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { createStagesReport } from './ForecastUtils';
import DealForecastViz from './components/DealForecastViz';
import { jsx as _jsx } from "react/jsx-runtime";
export function DealForecast(_ref) {
  let {
      report: baseReport,
      disableSVGs = false,
      isMobile: isMobile
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const report = createStagesReport(baseReport);
  if (disableSVGs) {
    return /*#__PURE__*/_jsx(PlatformReportResolver, Object.assign({
      report: report
    }, rest));
  }
  return /*#__PURE__*/_jsx(DealForecastViz, Object.assign({
    report: report,
    isMobile: isMobile
  }, rest));
}